<template>
  <div class="container-fluid">
    <b-row class="admin-page">
      <div class="col-md-8">
        <b-form class="admin-form" @submit.stop.prevent="submit">
          <b-form-group horizontal label="Field Name">
            <b-form-input type="text" v-model="fieldObject.name"></b-form-input>
          </b-form-group>
          <b-form-group horizontal label="Field Type">
            <v-select v-model="fieldObject.field_type" :options="fieldTypes" />
          </b-form-group>
          <b-form-group horizontal label="Linked Task Template">
            <v-select v-model="taskTemplate" :options="taskTemplatesCollection" />
          </b-form-group>
          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
      </div>
    </b-row>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
export default{
  name: 'NewField',
  data () {
    return {
      fieldObject: {},
      taskTemplate: {
        value: '',
        label: ''
      },
      fieldTypes: [
        'Number',
        'String',
        'Text',
        'Checkbox',
        'Date'
      ]
    }
  },
  methods: {
    ...mapActions(['addField', 'loadTaskTemplates', 'updateField']),
    submit () {
      if (this.fieldObject.id) {
        this.updateField(this.fieldObject)
      } else {
        this.addField(this.fieldObject)
      }
    }
  },
  created () {
    this.loadTaskTemplates()
  },
  computed: {
    ...mapGetters(['taskTemplatesCollection', 'field'])
  },
  watch: {
    taskTemplate () {
      this.fieldObject.task_template_id = this.taskTemplate.value
    },
    '$route.params.id' (id) {
      this.fieldObject = this.field(id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/fields/Form.vue